import axios from 'axios';
import { showTabs, selectTab } from '../../../common/tab/tabActions';
import consts from '../../../consts';
import { setErroAPI, setSuccess } from '../../../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../../../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PRODUTO_MODELO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('produtoModeloForm', registro)
    ];
}

export function getLista(idCategoriaModelo) {
    const request = axios.get(`${consts.API_URL}/produtoModelo?id_categoria_modelo=${idCategoriaModelo}`);
    return {
        type: 'PRODUTO_MODELO_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/produtoModelo`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_categoria_modelo));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/produtoModelo`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_categoria_modelo));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/produtoModelo?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(registro.id_categoria_modelo));
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaCor() {
    const request = axios.get(`${consts.API_URL}/cor/listarSelect`);
    return {
        type: 'PRODUTO_MODELO_COR_SELECT_LISTADO',
        payload: request
    };
}